import React from 'react';
import { CheckIcon, StarIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="relative w-full min-h-screen flex items-center overflow-hidden" style={{
    background: 'linear-gradient(160deg, #FDF8F3 0%, #F5EDE0 50%, #EDE0D0 100%)'
  }} aria-label="Sección principal" data-id="element-168">
      {/* Decorative background blobs */}
      <div className="absolute top-0 right-0 w-96 h-96 rounded-full opacity-20 blur-3xl pointer-events-none" style={{
      background: 'var(--blush)'
    }} data-id="element-169" />
      <div className="absolute bottom-0 left-0 w-80 h-80 rounded-full opacity-15 blur-3xl pointer-events-none" style={{
      background: 'var(--sage)'
    }} data-id="element-170" />

      <div className="relative z-10 max-w-3xl mx-auto px-6 py-10 lg:py-14 w-full" data-id="element-171">
        <div className="grid grid-cols-1 gap-16 items-center" data-id="element-172">
          {/* Left: Copy */}
          <div className="flex flex-col gap-6" data-id="element-173">
            {/* Badge */}
            <div className="flex items-center gap-1" data-id="element-174">
              <div className="flex" data-id="element-175">
                <StarIcon className="w-4 h-4 fill-current" style={{
                color: 'var(--gold)'
              }} aria-hidden="true" data-id="element-176" />
                <StarIcon className="w-4 h-4 fill-current" style={{
                color: 'var(--gold)'
              }} aria-hidden="true" data-id="element-177" />
                <StarIcon className="w-4 h-4 fill-current" style={{
                color: 'var(--gold)'
              }} aria-hidden="true" data-id="element-178" />
                <StarIcon className="w-4 h-4 fill-current" style={{
                color: 'var(--gold)'
              }} aria-hidden="true" data-id="element-179" />
                <StarIcon className="w-4 h-4 fill-current" style={{
                color: 'var(--gold)'
              }} aria-hidden="true" data-id="element-180" />
              </div>
              <span className="text-sm font-bold tracking-widest uppercase" style={{
              color: 'var(--gold-dark)'
            }} data-id="element-181">
                Método Dulce Libertad
              </span>
            </div>

            {/* Main headline */}
            <h1 className="text-4xl md:text-5xl xl:text-6xl font-bold leading-tight text-center" style={{
            color: 'var(--brown)',
            fontFamily: 'Playfair Display, serif'
          }} data-id="element-182">
              Disfruta postres irresistibles sin inflamarte, sin azúcar{' '}
              <em className="italic" style={{
              color: 'var(--gold-dark)'
            }} data-id="element-183">
                y sin culpa
              </em>
            </h1>

            {/* Subheadline */}
            <p className="text-lg md:text-xl leading-relaxed" style={{
            color: '#1a0f0a',
            fontFamily: 'Cormorant Garamond, serif',
            fontStyle: 'italic',
            fontSize: '1.25rem',
            fontWeight: 600
          }} data-id="element-184">
              52 recetas de alta pastelería sin gluten, sin lácteos y sin
              azúcar, explicadas paso a paso con ingredientes que consigues en
              tu supermercado.
            </p>

            {/* Trust bullets */}

            {/* Price + CTA */}
            <div className="flex flex-col gap-4 md:gap-8" data-id="element-185">
              <CTAButton text="DESCARGAR AHORA" subtext="Acceso inmediato • PDF en cualquier dispositivo • Garantía 30 días" showCarousel={true} scrollTo="precio" data-id="element-186" />
            </div>
          </div>

          {/* Right: Product image */}
          <div className="flex flex-col items-center gap-2" data-id="element-187">
            <div className="relative" data-id="element-188">
              <div className="absolute inset-0 rounded-3xl blur-2xl opacity-30 scale-95" style={{
              background: 'var(--gold-light)'
            }} data-id="element-189" />
              <img src="https://cdn.magicpatterns.com/uploads/1xeyM8XY99HJAJT6xgmREj/heroprod.jpg" alt="Dulce Libertad — Ebook con 52 recetas de repostería sin gluten, sin lácteos y sin azúcar" className="relative z-10 w-full max-w-lg rounded-2xl shadow-2xl mb-[15px] -mt-8" style={{
              objectFit: 'cover'
            }} data-id="element-190" />
            </div>

            {/* Trust bullets — below product image */}
            <ul className="flex flex-col gap-3 w-full max-w-lg" role="list" data-id="element-191">
              <li className="flex items-center gap-3" data-id="element-192">
                <span className="w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0" style={{
                background: 'var(--sage)'
              }} data-id="element-193">
                  <CheckIcon className="w-3.5 h-3.5 text-white" aria-hidden="true" data-id="element-194" />
                </span>
                <span style={{
                color: 'var(--brown-light)'
              }} data-id="element-195">
                  52 recetas probadas con familias reales
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-196">
                <span className="w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0" style={{
                background: 'var(--sage)'
              }} data-id="element-197">
                  <CheckIcon className="w-3.5 h-3.5 text-white" aria-hidden="true" data-id="element-198" />
                </span>
                <span style={{
                color: 'var(--brown-light)'
              }} data-id="element-199">
                  Ingredientes fáciles de conseguir en el de supermercado
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-200">
                <span className="w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0" style={{
                background: 'var(--sage)'
              }} data-id="element-201">
                  <CheckIcon className="w-3.5 h-3.5 text-white" aria-hidden="true" data-id="element-202" />
                </span>
                <span style={{
                color: 'var(--brown-light)'
              }} data-id="element-203">
                  Garantía de 30 días sin preguntas
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}